import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["option", "hiddenField", "submitButton", "skipLink"]

  select(event) {
    const value = event.currentTarget.dataset.value

    this.hiddenFieldTarget.value = value

    this.optionTargets.forEach((option) => {
      option.classList.toggle("c-scale-option--selected", option.dataset.value === value)
    })

    this.submitButtonTarget.classList.remove("tw-hidden")
    this.skipLinkTarget.classList.add("tw-hidden")
  }
}
